module.exports = __webpack_public_path__ + "img/18_Middle-Rectum.eeb93fc7.png";